export { default } from './HeaderSliderBlock'
